(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sb-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-sticky-atc')) {
    customElements.define(
      'sb-sticky-atc',
      class SbStickyAtc extends HTMLElement {
        connectedCallback() {
          this.info = document.querySelector('.product__info-container');
          // the main form's button only; „Pasujące dodatki” put more add buttons in the same column
          this.real = this.info && this.info.querySelector('button[id^="ProductSubmitButton-"][id$="__main"]');
          if (!this.real || !window.IntersectionObserver) return;
          this.btn = this.querySelector('[data-sb-satc-btn]');
          this.price = this.querySelector('[data-sb-satc-price]');
          this.phone = window.matchMedia('(max-width: 749px)');
          this.btn.addEventListener('click', () => {
            if (this.btn.disabled) return;
            this.real.click();
          });
          this.inView = true;
          new IntersectionObserver((entries) => {
            this.inView = entries[entries.length - 1].isIntersecting;
            this.update();
          }).observe(this.real);
          const sync = () => this.sync();
          new MutationObserver(sync).observe(this.real, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
            characterData: true,
          });
          new MutationObserver(sync).observe(this.info, { childList: true, subtree: true });
          this.phone.addEventListener('change', () => this.update());
          this.sync();
        }

        sync() {
          const label = this.real.querySelector('span');
          const text = ((label && label.textContent) || this.real.textContent).trim();
          if (text && this.btn.textContent !== text) this.btn.textContent = text;
          this.btn.disabled = this.real.disabled || this.real.getAttribute('aria-disabled') === 'true';
          const box = this.info.querySelector('.price');
          if (box) {
            const item = box.classList.contains('price--on-sale')
              ? box.querySelector('.price__sale .price-item--last')
              : box.querySelector('.price__regular .price-item--regular');
            const value = item && item.textContent.trim();
            if (value && this.price.textContent !== value) this.price.textContent = value;
          }
          this.update();
        }

        update() {
          const show = this.phone.matches && !this.inView && !this.btn.disabled;
          this.hidden = !show;
          this.inert = !show;
          document.body.classList.toggle('sb-satc-on', show);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
